module.exports = __webpack_public_path__ + "img/icon_grid_up.bf9cbeb5.svg";